import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
  ReferenceField,
  NumberField,
  ReferenceManyField,
  Datagrid,
  FunctionField,
} from 'react-admin';

export const CategoryShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="description" />
      
      <FunctionField
        label="Category Image"
        render={(record: any) => {
          const image = record.image;
          if (!image) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const imageUrl = image.thumbnails?.find((t: any) => t.size === 'medium')?.url || image.url;
          
          return (
            <img 
              src={imageUrl} 
              alt={record.name} 
              style={{ maxWidth: 200, maxHeight: 200, objectFit: 'cover' }} 
            />
          );
        }}
      />
      
      <FunctionField
        label="Category Icon"
        render={(record: any) => {
          const icon = record.icon;
          if (!icon) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const iconUrl = icon.thumbnails?.find((t: any) => t.type === 'W550')?.url || icon.url;
          
          return (
            <img 
              src={iconUrl} 
              alt={record.name} 
              style={{ maxWidth: 100, maxHeight: 100, objectFit: 'cover' }} 
            />
          );
        }}
      />
      
      <ReferenceField source="parentId" reference="categories" link="show" emptyText="Root Category">
        <TextField source="name" />
      </ReferenceField>
      
      <NumberField source="sortOrder" />
      <BooleanField source="isActive" />
      
      <ReferenceManyField reference="categories" target="parentId" label="Subcategories">
        <Datagrid>
          <TextField source="name" />
          <TextField source="slug" />
          <NumberField source="sortOrder" />
          <BooleanField source="isActive" />
        </Datagrid>
      </ReferenceManyField>
      
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
